//
// Each filter group has a defined key.
// The actual filter values are prefixed with this key
// The key must end with a $ sign
// The key must not contain a @ or # character because these are used in the storageKey format
// Storage format: {field}#{count1}@{field}#{count2}@{...}
// -> Field format: {group}${value}
//
// This means that values to filter on cannot contain $, @ or #
// Normally this will be oke for database Id's (numbers) or Guid's
//
export enum FilterTenantGroupKeys {
  subscriptionType = 'subscriptionType$',
  trial = 'trial$',
  standards = 'standards$',
}

//A value in the subscription type group that excludes grouping containers instead of including a type.
//Tenant Admin only: containers are org units that carry no subscription, licenses or data.
export const FilterTenantHideContainersValue = 'hideContainers';

//A value in the subscription type group that excludes org units (tenants with a parent) instead of including a type.
//Tenant Admin only, like hide containers.
export const FilterTenantHideOrgUnitsValue = 'hideOrgUnits';

//A value in the status group that is not a TenantStatus: the organization is a partner.
export const FilterTenantIsPartnerValue = '10';
